import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Trophy, Sparkles, X } from "lucide-react";
import { api } from "../lib/api";

/** Global Spin-to-Win winners banner — rotates through recent winners. */
export default function SpinWinnersBanner({ linkToSpin = true }) {
  const nav = useNavigate();
  const [winners, setWinners] = useState([]);
  const [idx, setIdx] = useState(0);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    api.get("/spin/winners").then((r) => setWinners(r.data || [])).catch(() => {});
  }, []);

  useEffect(() => {
    if (dismissed || winners.length < 2) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % winners.length), 5000);
    return () => clearInterval(t);
  }, [winners.length, dismissed]);

  if (dismissed || !winners.length) return null;
  const w = winners[idx];
  const prizeLabel = w.prize_type === "cash" && w.won_amount > 0
    ? `GH₵ ${Number(w.won_amount).toFixed(2)} cash`
    : w.prize_name;

  return (
    <div data-testid="spin-winners-banner" className="icaard-winner-banner">
    <button
      type="button"
      onClick={() => linkToSpin && nav("/app/spin")}
      className="w-full rounded-2xl border border-[#F5B400]/40 px-4 py-3 flex items-center gap-3 text-left transition-transform hover:scale-[1.005]"
      style={{ background: "linear-gradient(90deg, rgba(245,180,0,0.12) 0%, rgba(109,40,255,0.14) 100%)" }}
    >
      <div className="w-9 h-9 rounded-full bg-[#F5B400]/20 text-[#F5B400] flex items-center justify-center flex-shrink-0">
        <Trophy size={17} />
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-[9px] tracking-[0.28em] uppercase font-black text-[#F5B400] flex items-center gap-1">
          <Sparkles size={9} /> Spin to Win · Latest winner
        </div>
        <div className="text-sm font-bold text-white truncate" data-testid="spin-winner-line">
          🎉 {w.display_name} just won {prizeLabel}
        </div>
      </div>
      {linkToSpin && <span className="text-[10px] font-bold text-[#A78BFA] flex-shrink-0">Play →</span>}
    </button>
    <button type="button" aria-label="Dismiss latest winner" className="icaard-winner-close" onClick={() => setDismissed(true)}><X size={15} /></button>
    </div>
  );
}
